<ng-select
        class="custom"
        bindValue="name"
        [items]="items"
        placeholder="{{placeHolder | translate}}"
        [formControl]="bomType"
        [clearable]="clearable"
        (change)="onInput($event)"
        (blur)="onTouched()"
>

</ng-select>